import React from 'react';

interface CreditCardIconProps {
  className?: string;
}

const CreditCardIcon = ({ className = '', ...props }: CreditCardIconProps) => (
  <svg data-testid="creditCardIcon" width={20} height={16} className={className} {...props}>
    <defs>
      <path
        d="M18 0H2C.89 0 .01.89.01 2L0 14c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V2c0-1.11-.89-2-2-2zm-1 14H3c-.55 0-1-.45-1-1V8h16v5c0 .55-.45 1-1 1zm1-10H2V2h16v2z"
        id="creditCardIcon_svg__a"
      />
    </defs>
    <use fill="CurrentColor" xlinkHref="#creditCardIcon_svg__a" fillRule="evenodd" />
  </svg>
);

export default CreditCardIcon;
